import { render } from "./AdminMpRejectedValidationDetail.vue?vue&type=template&id=65fbc368&scoped=true"
import script from "./AdminMpRejectedValidationDetail.vue?vue&type=script&lang=js"
export * from "./AdminMpRejectedValidationDetail.vue?vue&type=script&lang=js"

import "./AdminMpRejectedValidationDetail.vue?vue&type=style&index=0&id=65fbc368&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fbc368"]])

export default __exports__